import React, { Component } from 'react';
import cn from 'classnames';
import styles from './Select.scss';

class Select extends Component {

  constructor(props) {
    super(props);

    this.state = {
      toggle: false
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.toggleInput = this.toggleInput.bind(this);
    this.selectedItem = this.selectedItem.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.refs.wrapperRef && !this.refs.wrapperRef.contains(event.target)) {
      this.setState(({ toggle: false }));
    }
  }

  selectedItem(event) {
    event.stopPropagation();
    const { onChange } = this.props;
    const { value } = event.target.dataset;
    this.toggleInput();
    onChange(value);
  }

  toggleInput() {
    this.setState(prev => ({ toggle: !prev.toggle }));
  }

  render() {
    const { toggle } = this.state;
    const { value, placeholder, options, onChange, isError, inputStyle = {}, ...other } = this.props;

    return (
      <div className={cn(styles.Select, toggle && styles.Open)} {...other} ref={'wrapperRef'}>
        <div className={styles.Backdrop} onClick={this.toggleInput} />
        <input style={{ ...inputStyle }} readOnly className={cn(styles.Input, isError && styles.InputError)} onClick={this.toggleInput} value={value} placeholder={placeholder} />
        <i onClick={this.toggleInput} className={toggle ? styles.ChevronUp : styles.ChevronDown} />
        <div className={styles.Dropdown}>
          <ul className={styles.List}>
            {options.map((item, index) =>
              <li style={{ ...inputStyle }} key={index} className={cn(styles.Item, item === value && styles.selected)} data-value={item} onClick={this.selectedItem}>{item}</li>
            )}
          </ul>
        </div>
      </div>
    );
  }
}

// eslint-disable-next-line import/prefer-default-export
export { Select };



// WEBPACK FOOTER //
// ./src/components/Login/FormRegistration/Select.js